<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="Unfalldokumentation"
        @change="reloadBaseFormData"
        @save="saveBaseFormData">
        <template v-if="formContext.permissions.canCreateRetroactiveChangesNote === true" v-slot:after-icons>
            <csp-retroactive-changes-modal :record-id="recordId" title="Unfalldokumentation"/>
        </template>
        <h2>Grunddaten Unfall</h2>
        <b-row>
            <b-col cols="2">
                <csp-desktop-info-card-element
                    :form-context="formContext"
                    label="Datum des Unfalls"
                    property="accidentDateTime"
                    :required="true"
                    type="datepicker"/>
                <csp-desktop-info-card-element
                    :form-context="formContext"
                    label="Anlieferungszeit"
                    property="deliveryTime"
                    :required="true"
                    step="60"
                    type="time"/>
            </b-col>
            <b-col cols="5">
                <csp-desktop-info-card-element
                    :form-context="formContext"
                    label="Unfallschilderung"
                    property="accidentDescription"
                    type="textarea"/>
            </b-col>
            <b-col cols="5">
                <b-row>
                    <b-col cols="6">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Straße"
                            property="accidentStreet"
                            type="text"/>
                    </b-col>
                    <b-col cols="6">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="PLZ"
                            property="accidentPostalCode"
                            type="text"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Ort"
                            property="accidentPlace"
                            type="text"/>
                    </b-col>
                    <b-col cols="6"/>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="2">
                <csp-desktop-info-card-element
                    :form-context="formContext"
                    label="Spedition"
                    :options-loader="loadDeliveryFirmOptions"
                    property="deliveryFirmId"
                    type="autocomplete"/>
            </b-col>
            <b-col cols="2">
                <csp-desktop-info-card-element
                    :form-context="formContext"
                    label="Lieferscheinnummer"
                    property="deliveryReceiptNumber"
                    type="text"/>
            </b-col>
        </b-row>
        <hr class="mb-5">
        <b-row class="grid">
            <b-col cols="4">
                <h2>Vorgang</h2>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :disabled="true"
                            :form-context="formContext"
                            label="Aktenzeichen AC"
                            property="referenceNumber"
                            type="text"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :disabled="true"
                            :form-context="formContext"
                            label="Aktenzeichen SD"
                            property="referenceNumberDamageServiceProvider"
                            type="text"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :disabled="true"
                            :form-context="formContext"
                            label="Aktenzeichen RA"
                            property="referenceNumberLawyer"
                            type="text"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Auftragsnummer"
                            property="orderNumber"
                            type="text"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="ist gesteuert"
                            property="isCaseSteered"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row v-if="formContext.form.getProperty('isCaseSteered') === 'yes'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Steuerungsart"
                            property="steeredCaseType"
                            type="autocomplete"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="ist werkstattgebunden"
                            property="isCommittedToWorkshop"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="wurde polizeilich aufgenommen"
                            property="isRecordedByPolice"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            :inversed="true"
                            label="Schädiger ist selbst Fahrer"
                            property="hasAdversaryDifferentDriver"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="4">
                <h2>Fahrzeug</h2>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :disabled="isCarLeasedDisabled"
                            :form-context="formContext"
                            label="ist geleast"
                            property="isCarLeased"
                            type="optionalBoolean"
                            @change="handleCarIsLeasedChange"/>
                    </b-col>
                </b-row>

                <b-row v-if="formContext.form.getProperty('isCarLeased') === 'yes'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Leasinggeber"
                            :options-loader="loadLeasingCompanyOptions"
                            property="leasingCompanyId"
                            type="autocomplete"/>
                    </b-col>
                </b-row>

                <b-row v-if="formContext.form.getProperty('isCarLeased') === 'yes'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Leasingvertragsnummer"
                            property="leasingContractNumber"
                            type="text"/>
                    </b-col>
                </b-row>

                <b-row v-if="formContext.form.getProperty('isCarLeased') === 'yes'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="IBAN des Leasinggebers"
                            property="leasingBankAccountIban"
                            type="text"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :disabled="isCarFinancedDisabled"
                            :form-context="formContext"
                            label="ist finanziert"
                            property="isCarFinanced"
                            type="optionalBoolean"
                            @change="handleCarIsFinancedChange"/>
                    </b-col>
                </b-row>

                <b-row v-if="formContext.form.getProperty('isCarFinanced') === 'yes'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Finanzierende Bank"
                            :options-loader="loadFinancingCompanyOptions"
                            property="financingCompanyId"
                            type="autocomplete"/>
                    </b-col>
                </b-row>

                <b-row v-if="formContext.form.getProperty('isCarFinanced') === 'yes'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Finanzierungsvertragsnummer"
                            property="financingContractNumber"
                            type="text"/>
                    </b-col>
                </b-row>

                <b-row v-if="formContext.form.getProperty('isCarFinanced') === 'yes'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="IBAN der finanzierenden Bank"
                            property="financingBankAccountIban"
                            type="text"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="wurde abgeschleppt"
                            property="wasCarTowed"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="wird repariert"
                            property="isCarGettingRepaired"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="voraussichtliche Schadenhöhe (in €)"
                            property="estimatedDamage"
                            type="autocomplete"/>
                    </b-col>
                </b-row>

                <b-row v-if="formContext.form.getProperty('isCarGettingRepaired') === 'no'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Grund für Nichtreparatur"
                            property="noRepairReason"
                            type="autocomplete"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Fahrzeug hat Vorschäden"
                            property="vehicleHasPreExistingDamages"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="ist verkehrssicher"
                            property="isRoadworthy"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="steht vor Ort"
                            property="vehicleIsOnSite"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Gravierende Neuteile - Teile die Sie erneuern möchten"
                            property="partsSeverelyDamaged"
                            type="textarea"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Auszubeulende Teile mit Arbeitszeit"
                            property="partsToRemoveOrRepair"
                            type="textarea"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Ausschließlich Teile die nur lackiert werden"
                            property="partsToOnlyRepaint"
                            type="textarea"/>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="4">
                <h2 v-if="!formContext.data.hasOwnProperty('hasDifferingPolicyholder')">
                    Geschädigter
                </h2>
                <h2 v-if="formContext.data.hasOwnProperty('hasDifferingPolicyholder')">
                    Versicherungsnehmer
                </h2>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="ist vorsteuerabzugsberechtigt"
                            property="isCustomerDeductingVatEntitled"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="ist abweichend vom Halter"
                            property="hasDifferingPolicyholder"
                            type="checkbox"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            :inversed="true"
                            label="ist selbst Fahrer"
                            property="hasCustomerDifferentDriver"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Eigenschaden"
                            property="isFirstPartyDamage"
                            type="checkbox"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="wurde verletzt (oder Insassen)"
                            property="hasInjured"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="nutzt einen Mietwagen"
                            property="isRentalCarUsed"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row v-if="formContext.form.getProperty('isRentalCarUsed') === 'yes'">
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Mietwagenherkunft"
                            property="carRentalSource"
                            type="autocomplete"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="ist vollkaskoversichert"
                            property="hasCustomerFullyComprehensiveInsurance"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="ist rechtschutzversichert"
                            property="isLegalProtectionInsured"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <csp-desktop-info-card-element
                            :form-context="formContext"
                            label="Schutzbrief vorhanden"
                            property="hasBreakdownCover"
                            type="optionalBoolean"/>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import InsuranceTypeEnum from '@js/enums/insurance/InsuranceTypeEnum';

    const container = Container.getInstance();
    const insuranceRepository = container.getDamageInsuranceRepository();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'VehicleBasedata',
        mixins: [FormDataMixin],
        provide() {
            return {
                emitFieldChange: (...args) => this.handleFormFieldChange(...args),
            }
        },
        data() {
            return {
                isCarLeasedDisabled: false,
                isCarFinancedDisabled: false,
            }
        },
        computed: {
            recordId() {
                return parseInt(this.$route.params.recordId);
            },
        },
        methods: {
            loadDeliveryFirmOptions() {
                return recordRepository.loadDeliveryFirmOptions(this.recordId);
            },
            loadFinancingCompanyOptions() {
                return insuranceRepository.findParentsForDropdown(InsuranceTypeEnum.BANK);
            },
            loadLeasingCompanyOptions() {
                return insuranceRepository.findParentsForDropdown(InsuranceTypeEnum.LESSOR);
            },
            handleCarIsFinancedChange(value) {
                if (value === 'yes') {
                    this.formContext.form.setProperty('isCarLeased', 'no');
                    this.formContext.form.setProperty('leasingCompanyId', null);
                    this.formContext.form.setProperty('leasingContractNumber', '');
                    this.formContext.form.setProperty('leasingBankAccountIban', '');
                    this.isCarLeasedDisabled = true;
                } else {
                    this.formContext.form.setProperty('financingCompanyId', null);
                    this.formContext.form.setProperty('financingContractNumber', '');
                    this.formContext.form.setProperty('financingBankAccountIban', '');
                    this.isCarLeasedDisabled = false;
                }
            },
            handleCarIsLeasedChange(value) {
                if (value === 'yes') {
                    this.formContext.form.setProperty('isCarFinanced', 'no');
                    this.formContext.form.setProperty('financingCompanyId', null);
                    this.formContext.form.setProperty('financingContractNumber', '');
                    this.formContext.form.setProperty('financingBankAccountIban', '');
                    this.isCarFinancedDisabled = true;
                } else {
                    this.formContext.form.setProperty('leasingCompanyId', null);
                    this.formContext.form.setProperty('leasingContractNumber', '');
                    this.formContext.form.setProperty('leasingBankAccountIban', '');
                    this.isCarFinancedDisabled = false;
                }
            },
            handleFormFieldChange(formContext, property) {
                if (
                    Array.isArray(formContext.reloadFields) &&
                    formContext.reloadFields.includes(property)
                ) {
                    this.reloadBaseFormData(formContext)
                }
            },
            saveBaseFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveAccidentDocumentationBasedata(this.recordId, postData)
                }
                this.saveFormData(formContext, saveFunction, null)
            },
            reloadBaseFormData(formContext) {
                const reloadFunction = (objectId, postData) => {
                    return recordRepository.reloadAccidentDocumentationBasedata(this.recordId, postData)
                }
                this.reloadFormData(formContext, reloadFunction, null)
            },
        },
    }
</script>
